import { Text } from "@chakra-ui/react";
import { formatStringWithCommas } from "@syla/shared/helpers/formatting";
import { SubscriptionWithPlansAndAccess } from "@syla/shared/types/responses/GetSubscriptionsResponse";
import { getSubscriptionState } from "@syla/shared/types/subscriptions/getSubscriptionState";
import { Lifecycle } from "@syla/shared/types/subscriptions/subscriptionState";
import React from "react";
import { SettingRowBase } from "../components/SettingRowBase";

interface TransactionCapProps {
  subscription?: SubscriptionWithPlansAndAccess;
}

export const TransactionCap = ({
  subscription,
}: TransactionCapProps): React.ReactElement | null => {
  if (!subscription) {
    return null;
  }

  const transactionLimit = subscription.plan.features.transactionLimit;

  const state = getSubscriptionState(subscription);

  if (state.lifecycle === Lifecycle.Terminated) {
    return null;
  }

  const value = formatStringWithCommas(transactionLimit.toString());

  return (
    <SettingRowBase
      label="Transaction cap"
      description="The maximum number of transactions supported on your plan."
    >
      <Text>{value}</Text>
    </SettingRowBase>
  );
};
